import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { TitleText } from "../../../ui/Text";
import Table from "../../../ui/Table";
import Modal from "../../../ui/Modal";
import SettingsForm from "./SettingsForm";
import { GetHook } from "../../../api/api";
import { get } from "../../../utils/get";
import { PERIOD_URL, SETTINGS_URL } from "../../../api/urls";
import { useLocation } from "react-router-dom";
import { EditDeleteFormatter } from "../../../ui/TableFormatter";
import axios from "../../../utils/axios";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

const GlobalSettings = () => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [handleSubmit, setHandleSubmit] = useState();
  const [editData, setEditData] = useState({});
  const [edit, setEdit] = useState(false);
  const [step, setStep] = useState(1);
  const [settings, setSettings] = useState([]);
  const { data, error, pending, reload } = GetHook(SETTINGS_URL);
  const { data: periods } = GetHook(PERIOD_URL);

  const location = useLocation();

  useEffect(() => {
    setSettings(data);
    return () => {};
  }, [data]);

  const closeModal = () => {
    setStep(1);
    setEditData({});
    setisModalOpen(false);
    setEdit(false);
    reload(get(location, "key"));
  };

  const handleEdit: any = (row: any) => {
    setisModalOpen(true);
    setEdit(true);
    setEditData(row);
  };

  const handleDelete = (id: string) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        if (id) {
          axios
            .delete(`${SETTINGS_URL}/${id}`)
            .then((res) => {
              setSettings(settings.filter((setting: any) => setting.id != id));
              toast.success("Global settings has been deleted");
            })
            .catch((error) => toast.error(error.response.data.message));
        }
      }
    });
  };

  const columns = [
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "KPI min score",
      accessor: "min_score",
    },
    {
      Header: "KPI max score",
      accessor: "max_score",
    },
    {
      Header: "KPI target score",
      accessor: "target_score",
    },
    {
      Header: "period",
      accessor: "period.name",
    },
    {
      id: "1",
      Header: "",
      Cell: ({ row }: any) => (
        <EditDeleteFormatter
          showEdit={() => handleEdit(row.original)}
          handleDelete={() => handleDelete(row.original.id)}
        />
      ),
    },
  ];
  return (
    <GlobalSettingsContainer>
      <HeaderContainer>
        <TitleText>Global Settings</TitleText>
      </HeaderContainer>
      <Table data={settings} columns={columns} setModal={setisModalOpen} />

      <SettingsForm
        closeModal={closeModal}
        setHandleSubmit={setHandleSubmit}
        editData={editData}
        periods={periods}
        isModalOpen={isModalOpen}
        edit={edit}
        step={step}
        setStep={setStep}
      />
    </GlobalSettingsContainer>
  );
};

export default GlobalSettings;

const GlobalSettingsContainer = styled.div`
  display: grid;
  grid-template-rows: 5em auto;
  background-color: #fff;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.3em;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
`;
